'use strict';

angular.module('mobile-apps')
    .directive('tagsSelector', [
        'EntryMain',
        'TagMain',
        'LanguageEntries',
        '$stateParams',
        '$timeout',
        '$rootScope',
        'SweetAlert',
        function (
            EntryMain,
            TagMain,
            LanguageEntries,
            $stateParams,
            $timeout,
            $rootScope,
            SweetAlert
        ) {
            return {
                restrict: 'E',
                scope:
                {
                    postActionCallback: '&', // Optional
                    mobileAppId: '=',
                    selectedKeys: '=',
                    entries: '=',
                    tags: '=',
                    tagCategories: '=',
                    extendedFunctions: '='
                },
                templateUrl: 'modules/mobile-apps/views/tags-selector.client.directive.html',

                link: function (scope, element, attrs) {
                    scope.applyTags = false;
                    scope.displayTags = [];
                    scope.filteredList = [];
                    scope.selectedKeys = scope.selectedKeys || [];
                    scope.entries = scope.entries || [];
                    scope.tags = scope.tags || {};
                    scope.tagCategories = scope.tagCategories || [];
                    scope.newTagCategory = null;
                    scope.tagFilterString = '';
                    scope.tagChanges = {};
                    scope.tagsSelected = {};
                    scope.tagsSelectedStart = {};
                    scope.tagsUndetermined = {};
                    scope.tagsUndeterminedStart = {};
                    scope.tagSelectorOpen = false;
                    scope.prevFilterLength = 0;
                    scope.tagStatus = { isOpen: false, changed: false };

                    scope.selectedTags = [];

                    scope.top = 0;
                    scope.left = 0;
                    scope.minWidth = 0;

                    scope.tagsPosition = {
                        top: 0,
                        left: 0,
                        minWidth: 0
                    };

                    scope.categoriesPosition = {
                        top: 0,
                        left: 0,
                        minWidth: 0
                    };

                    /**
                     * Returns array of currently selected entries
                    */
                    scope.getSelectedEntries = function () {
                        var selectedEntries = [];
                        scope.entries.forEach(function (entry) {
                            if (entry.selected === true) {
                                selectedEntries.push(entry);
                            }
                        });

                        if (!selectedEntries.length) {
                            selectedEntries = scope.entries.filter(function (item) {
                                return item.key === scope.selectedKeys[0];
                            });
                        }

                        return selectedEntries;
                    };

                    scope.adjustDropdownPosition = function(){
                        $timeout(function(){
                            var searchBox = $('#txtTagFilterString');
                            var searchBoxPosition = searchBox.position();
                            scope.tagsPosition.top = searchBoxPosition.top + 19;
                            scope.tagsPosition.left = searchBoxPosition.left;
                            scope.tagsPosition.minWidth = searchBox.outerWidth();
                        }, 33);
                    };


                    /**
                     * Initializes the tag-list
                     */
                    scope.init = function () {
                        var selectedEntries = scope.getSelectedEntries();

                        // Init containsTagsCount and displayTags
                        var containsTagsCount = {};
                        scope.displayTags.length = 0;
                        Object.keys(scope.tags).forEach(function (tagId) {
                            containsTagsCount[tagId] = 0;
                            scope.displayTags.push(scope.tags[tagId]);
                        });

                        // Count which tags are on which entries to be able to
                        // display checkboxes accordingly
                        selectedEntries.forEach(function (entry) {
                            if (entry._tags) {
                                entry._tags.forEach(function (tagId) {
                                    containsTagsCount[tagId]++;
                                });
                            }
                        });

                        // Set the checkbox values
                        var numSelectedEntries = selectedEntries.length;
                        Object.keys(scope.tags).forEach(function (tagId) {
                            if (containsTagsCount[tagId] === 0) {
                                scope.tagsSelected[tagId] = false;
                                scope.tagsUndetermined[tagId] = false;
                            } else {
                                scope.tagsSelected[tagId] = containsTagsCount[tagId] === numSelectedEntries;
                                scope.tagsUndetermined[tagId] = containsTagsCount[tagId] < numSelectedEntries;
                            }
                            scope.tagsSelectedStart[tagId] = scope.tagsSelected[tagId];
                            scope.tagsUndeterminedStart[tagId] = scope.tagsUndetermined[tagId];
                        });

                        scope.updateTagsParent();
                        scope.adjustDropdownPosition();
                    };


                    scope.handleApplyTagsCheckboxClick = function () {
                        scope.tagStatus.isOpen = !scope.applyTags;
                        if (scope.applyTags === true) {
                            scope.tagFilterString = '';
                        }
                    };

                    scope.displayTagsDropdown = function ($event) {
                        scope.tagStatus.isOpen = scope.applyTags;
                    };

                    /**
                     * Special callback when checkbox gets clicked to know when
                     * an undetermined checkbox got clicked
                     */
                    scope.toggledCheckbox = function (tagId) {
                        if (scope.tagsUndetermined[tagId] === true) {
                            scope.tagsUndetermined[tagId] = false;
                            scope.tagsSelected[tagId] = false;
                        }

                        scope.tagStatus.changed = true;
                        scope.adjustDropdownPosition();
                        $timeout(function(){
                            scope.updateTagsParent();
                        }, 33);
                    };

                    scope.getTagCategoryIcon = function (categoryName) {
                        if (scope.tagCategories && categoryName) {
                            var category = scope.tagCategories.find(function (item) { return item.name.toLowerCase() === categoryName.toLowerCase(); });
                            if (category) {
                                return category.icon;
                            }
                        }
                        return;
                    };

                    scope.getTagCategoryColor = function (categoryName) {
                        if (scope.tagCategories && categoryName) {
                            var category = scope.tagCategories.find(function (item) { return item.name.toLowerCase() === categoryName.toLowerCase(); });
                            if (category) {
                                return category.color;
                            }
                        }
                        return;
                    };

                    scope.getTagCategoryName = function (categoryName) {
                        if (scope.tagCategories && categoryName) {
                            var category = scope.tagCategories.find(function (item) { return item.name.toLowerCase() === categoryName.toLowerCase(); });
                            if (category) {
                                return category.name;
                            }
                        }
                        return 'None';
                    };

                    scope.getSelectedTags = function () {
                        var selectedTags = [];
                        Object.keys(scope.tagsSelected).forEach(function (tagKey) {
                            if (scope.tagsSelected[tagKey] === true) {
                                selectedTags.push(scope.tags[tagKey]);
                            }
                        });

                        return selectedTags;
                    };

                    scope.openCategorySelector = function () {
                        scope.tagSelectorOpen = !scope.tagSelectorOpen;
                    };

                    scope.updateSelectedCategory = function (categoryName) {
                        scope.newTagCategory = categoryName;
                        scope.tagSelectorOpen = false;
                        $('#statusTaggingCategorySelector').removeClass('open');
                    };

                    // Reset the list alway when the dropdown gets closed. If that
                    // does not get done the checkbox undeterminded value does
                    // not always get reset correctly
                    scope.$watch('tagStatus.isOpen', function (isOpen) {
                        if (scope.tagSelectorOpen || (scope.filteredList.length === 0 && scope.tagFilterString !== '') && isOpen === false && scope.applyTags) {
                            scope.tagStatus.isOpen = true;
                            if (scope.tagSelectorOpen) {
                                $('#statusTaggingCategorySelector').addClass('open');
                            }
                        } else if (isOpen === false) {
                            scope.tagStatus.isOpen = false;
                            scope.tagSelectorOpen = false;
                            //scope.displayTags.length = 0;
                            $('#statusTaggingCategorySelector').removeClass('open');
                        }
                    });

                    // Watching filter so that tag category dropdown adjust to its width
                    scope.$watch('tagFilterString', function (filterString) {
                        $timeout(function () {
                            var categoriesBtn = $('#btnStatusTaggingCategorySelect');
                            var categoriesBtnPosition = categoriesBtn.position();
                            scope.categoriesPosition.minWidth = $('#btnCreateSelectedTags').outerWidth();
                            scope.categoriesPosition.top = categoriesBtnPosition.top - 14;
                            scope.categoriesPosition.left = categoriesBtnPosition.left + scope.categoriesPosition.minWidth + 14;
                        }, 33);
                    });

                    scope.createTag = function (tagName) {
                        scope.tagFilterString = '';
                        TagMain.createTag({ name: tagName, category: scope.newTagCategory }, function (err, newTag) {
                            if (err) {
                                $timeout(function () {
                                    SweetAlert.swal(
                                        {
                                            title: 'Oops!',
                                            text: 'Sorry something went wrong',
                                            type: 'error',
                                            showCancelButton: false
                                        }
                                    );
                                }, 50);
                                return;
                            }

                            scope.newTagCategory = null;
                            scope.tagChanges[newTag._id] = 'add';
                            scope.tags[newTag._id] = newTag;
                            scope.displayTags.push(newTag);
                            scope.tagsSelected[newTag._id] = true;
                            scope.tagStatus.changed = true;
                            scope.tagSelectorOpen = false;
                            scope.tagStatus.isOpen = false;
                            scope.updateTagsParent();
                            setTimeout(function () {
                                scope.tagStatus.isOpen = true;
                            }, 33);
                        });
                    };

                    scope.applySelectedTags = function () {
                        scope.tagStatus.isOpen = false;
                    };

                    /**
                     * Applies the given tag changes
                     */
                    scope._applyTagChanges = function () {
                        scope.tagStatus.isOpen = false;
                        var selectedEntries = scope.getSelectedEntries();

                        var keys = selectedEntries.map(function (entry) { return entry.key; });

                        LanguageEntries.addRemoveTags({
                            mobileAppId: scope.mobileAppId,
                            tags: scope.tagChanges,
                            entries: keys
                        }, function (response) {
                            $rootScope.$broadcast('entriesChanged');
                            // if (angular.isFunction(scope.postActionCallback)) {
                            // 	scope.postActionCallback(selectedKeys, selectedKeys);
                            // }
                        }, function (errorResponse) {
                            $timeout(function () {
                                SweetAlert.swal(
                                    {
                                        title: 'Oops!',
                                        text: 'Sorry something went wrong',
                                        type: 'error',
                                        showCancelButton: false
                                    }
                                );
                            }, 50);
                        });
                    };

                    scope.save = function(){
                        // Check what changed and create an object which specifies
                        // which tags should get added and/or removed from the
                        // currently selected entries.
                        Object.keys(scope.tagsSelectedStart).forEach(function (tagId) {
                            if (scope.tagsSelectedStart[tagId] !== scope.tagsSelected[tagId]) {
                                if (scope.tagsSelected[tagId] === true) {
                                    // Add Tag to entries
                                    scope.tagChanges[tagId] = 'add';
                                } else {
                                    // Remove Tag from entries
                                    scope.tagChanges[tagId] = 'remove';
                                }
                            } else if (scope.tagsUndeterminedStart[tagId] !== scope.tagsUndetermined[tagId]) {
                                // Remove Tag from entries
                                scope.tagChanges[tagId] = 'remove';
                            }
                        });

                        scope._applyTagChanges(scope.tagChanges);
                    };

                    scope.handleModalClick = function ($event) {
                        var targetId = $event.target.id;
                        var targetClass = $event.target.className;
                        if (targetId !== 'txtTagFilterString' && targetId !== 'chxTagSelector' && targetId !== 'lblTagSelector' &&
                            targetId !== 'lblTagIcon' && targetId !== 'lblTagName' && targetId !== 'tagging-dropdown' && !targetId.includes('tagging') &&
                            !targetClass.includes('tagging-dropdown')) {
                            scope.tagStatus.isOpen = false;
                        }
                    };

                    scope.updateTagsParent = function(){
                        if(angular.isFunction(scope.extendedFunctions.updateTagsPropsParent)){
                            scope.extendedFunctions.updateTagsPropsParent(scope.applyTags, scope.getSelectedTags());
                        }
                    };


                    /**
                     * Extending an imported object property so that the 
                     * function can be called from the parent
                     */
                    if(scope.extendedFunctions){
                        angular.extend(scope.extendedFunctions, {
                            saveTags: function(){
                                return scope.save();
                            } 
                        });
                    }

                    scope.init();
                }
            };
        }]);
